export default {"src":"/_next/static/media/ProfilePlaceholder.29827e56.svg","height":20,"width":20};